import { render, staticRenderFns } from "./DeleteVacation.vue?vue&type=template&id=a510b0b8&"
import script from "./DeleteVacation.vue?vue&type=script&lang=js&"
export * from "./DeleteVacation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports